import React from "react"
import { createPortal } from "react-dom"

type Props = { children: React.ReactNode }

export default function ModalPortal({ children }: Props) {
  const element = typeof document !== "undefined" ? document.body : null

  if (!element) {
    return null
  }

  return createPortal(children, element)
}
